'use client';
import React from 'react';
import { FiboSearchType, TaxonomyType } from '@/constants/fibo/fibosearch';
import type { FiboCollectionComboboxItem } from '@/models/fibo/fibosearch';
import { Image, Text } from '@chakra-ui/react';
import { extractImageSrc } from '@/components/fibosearch/FibosearchCombobox/utils';
import { BrandItem, ProductItem } from './Items';
import { HighlightedText } from './HighlightedText';
import NextImage from 'next/image';
import { useSafeRouter } from '@/hooks/route/useSafeRouter';
import { isEmpty } from 'es-toolkit/compat';

export type RenderItemProps = {
  item: FiboCollectionComboboxItem;
  inputValue: string;
};

export const RenderItem = ({ item, inputValue }: RenderItemProps) => {
  const router = useSafeRouter();

  // Render based on item type instead of groupType
  if (item.type === FiboSearchType.TAXONOMY) {
    const isProductCategory = item.taxonomy === TaxonomyType.PRODUCT_CATEGORY;

    return (
      <BrandItem item={item} onClick={() => router.push(item.url)}>
        <HighlightedText value={item.label} match={inputValue} />
        {isProductCategory && !isEmpty(item.breadcrumbs) && (
          <Text textStyle="caption1" color="neutral.60">
            in {item.breadcrumbs}
          </Text>
        )}
      </BrandItem>
    );
  }

  if (item.type === FiboSearchType.PRODUCT) {
    return (
      <ProductItem item={item} onClick={() => router.push(item.url)}>
        <Image
          alt={item.label}
          asChild
          border="1px solid"
          borderColor="neutral.10"
          borderRadius="4px"
          padding="4px"
          backgroundColor="white"
        >
          <NextImage src={extractImageSrc(item.thumbHtml)} alt={item.label} width={44} height={44} />
        </Image>

        <HighlightedText value={item.label} match={inputValue} />
      </ProductItem>
    );
  }

  return null;
};
